import { DependencyList, useEffect, useRef } from 'react';

import { isNil } from 'src/utils/is-nil';

// will fire the callback only once when all the dependencies are defined
const useEffectOnce = (callback: () => void, dependencies: DependencyList) => {
  const rendered = useRef(false);

  useEffect(() => {
    if (rendered.current || dependencies.some(isNil)) return;

    callback();
    rendered.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useEffectOnce;
